import { connect } from 'react-redux';
import { initializeSeriesEvents } from '../../actions/series';
import { getSeriesIsLoading } from '../../selectors/series';

export const connectSeriesPage = (ComponentClass) =>
    connect(
        (state) => ({
            isLoading: getSeriesIsLoading(state),
        }),
        (dispatch) => ({
            onPageMounted: () => dispatch(initializeSeriesEvents()),
        }),
    )(ComponentClass);
